const Coupon = () => {
  return (
    <div className=" m-4 relative w-[329px] h-[172px]  rounded-lg coupon-bg">
      <div className=" -left-3 absolute w-[40px] h-[40px] rounded-full bg-white bottom-1/2 translate-y-1/2 "></div>
      <div className=" -right-6 absolute w-[40px] h-[40px] rounded-full bg-white bottom-1/2 translate-y-1/2 "></div>
      <div className=" grid grid-cols-12">
        <div className=" col-span-3">
          <div>
            <p
              style={{ color: "rgba(255, 255, 255, 0.35)" }}
              className=" absolute ltr:-left-2 rtl:-right-14 top-10 origin-bottom -rotate-90 text-[30px] font-bold inline-block"
            >
              DISCOUNT
            </p>
          </div>
        </div>

        <div className=" col-span-1 relative">
          <div className="">
            <svg
              width="1"
              height="152"
              viewBox="0 0 1 152"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="0.5"
                x2="0.5"
                y2="152"
                stroke="#969696"
                stroke-opacity="0.6"
                stroke-dasharray="6 6"
              />
            </svg>
            <div className="absolute   ltr:-left-2.5 rtl:-right-2.5  -bottom-1">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.9004 1.49679C15.9898 1.33779 16.1386 1.2208 16.3142 1.17155C16.4898 1.1223 16.6778 1.14482 16.8368 1.23416C16.9958 1.32351 17.1128 1.47236 17.1621 1.64796C17.2113 1.82356 17.1888 2.01154 17.0994 2.17054L11.7883 11.6159L14.2706 16.0296C14.5839 15.3189 15.1286 14.7352 15.816 14.3735C16.5034 14.0119 17.293 13.8936 18.0562 14.038C18.8194 14.1825 19.5112 14.581 20.0189 15.1688C20.5267 15.7566 20.8205 16.499 20.8524 17.2751C20.8844 18.0511 20.6526 18.8152 20.1949 19.4427C19.7372 20.0702 19.0805 20.5243 18.3318 20.731C17.583 20.9377 16.7864 20.8847 16.0716 20.5808C15.3568 20.2769 14.7659 19.74 14.3953 19.0574L10.9999 13.0184L7.6046 19.0574C7.23397 19.7397 6.64324 20.2764 5.92863 20.5802C5.21402 20.8839 4.41762 20.9367 3.66915 20.7301C2.92067 20.5234 2.2642 20.0695 1.80666 19.4421C1.34912 18.8147 1.11745 18.051 1.1494 17.2751C1.18134 16.4993 1.47501 15.7572 1.98258 15.1695C2.49015 14.5819 3.18171 14.1835 3.94465 14.039C4.70758 13.8946 5.49694 14.0128 6.18416 14.3742C6.87138 14.7357 7.41598 15.3191 7.72927 16.0296L10.2116 11.6159L4.90044 2.17054C4.81109 2.01154 4.78857 1.82356 4.83782 1.64796C4.88707 1.47236 5.00407 1.32351 5.16306 1.23416C5.32206 1.14482 5.51004 1.1223 5.68564 1.17155C5.86125 1.2208 6.01009 1.33779 6.09944 1.49679L10.9999 10.2134L15.9004 1.49679ZM4.58327 19.479C4.94654 19.4792 5.30342 19.3834 5.61778 19.2014C5.93215 19.0193 6.19285 18.7574 6.37352 18.4423L6.39185 18.4093C6.60947 18.013 6.69084 17.5562 6.62346 17.1091C6.55607 16.6621 6.34367 16.2495 6.01891 15.935C5.69416 15.6205 5.27505 15.4214 4.82607 15.3683C4.37709 15.3152 3.92311 15.4112 3.53398 15.6413C3.14485 15.8715 2.84213 16.2231 2.67238 16.6422C2.50264 17.0612 2.47528 17.5244 2.59452 17.9605C2.71375 18.3966 2.97298 18.7814 3.33231 19.0558C3.69164 19.3302 4.13117 19.4789 4.58327 19.479ZM17.4166 19.479C17.0533 19.4792 16.6965 19.3834 16.3821 19.2014C16.0677 19.0193 15.807 18.7574 15.6264 18.4423L15.608 18.4093C15.3904 18.013 15.309 17.5562 15.3764 17.1091C15.4438 16.6621 15.6562 16.2495 15.981 15.935C16.3057 15.6205 16.7248 15.4214 17.1738 15.3683C17.6228 15.3152 18.0768 15.4112 18.4659 15.6413C18.855 15.8715 19.1577 16.2231 19.3275 16.6422C19.4972 17.0612 19.5246 17.5244 19.4054 17.9605C19.2861 18.3966 19.0269 18.7814 18.6676 19.0558C18.3082 19.3302 17.8687 19.4789 17.4166 19.479Z"
                  fill="#969696"
                  fill-opacity="0.6"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className=" col-span-8">
          <div className="flex items-center gap-x-4 my-4">
            <div>
              <p className="text-[32px] font-bold text-own-black">20%</p>
            </div>
            <div className=" flex-grow">
              <p className="text-sm">Flat 20% off on all camping products</p>
            </div>
          </div>

          <div>
            <span className=" inline-block text-primary">Code: </span>
            <span className="inline-block text-primary">&nbsp;GET002214</span>
            <div className=" inline-block ltr:ml-2 rtl:mr-2 cursor-pointer">
              <svg
                width="14"
                height="15"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7188 4.5H5.78125C4.79749 4.5 4 5.29749 4 6.28125V13.2188C4 14.2025 4.79749 15 5.78125 15H12.7188C13.7025 15 14.5 14.2025 14.5 13.2188V6.28125C14.5 5.29749 13.7025 4.5 12.7188 4.5Z"
                  stroke="#AC7529"
                  strokeWidth="1.25"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9844 4.5L12 3.75C11.9987 3.28628 11.8139 2.84192 11.486 2.51402C11.1581 2.18612 10.7137 2.00132 10.25 2H3.5C2.97005 2.00157 2.46225 2.21278 2.08752 2.58752C1.71278 2.96225 1.50157 3.47005 1.5 4V10.75C1.50132 11.2137 1.68612 11.6581 2.01402 11.986C2.34192 12.3139 2.78628 12.4987 3.25 12.5H4"
                  stroke="#AC7529"
                  strokeWidth="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <p className="text-sm text-[#585858]">Valid till 20 Feb, 2024</p>
          <div className=" flex justify-end px-6 my-2">
            <p className=" font-bold text-primary">View detail</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coupon;
